import { combineReducers } from 'redux';
// 埋点数据
import eventTrackingState, {iEventTrackingState} from '@/eventTracking/redux-eventTracking.reducer'

export interface IRootState {
    eventTrackingState:iEventTrackingState
}

const rootReducer = combineReducers<IRootState>({
    eventTrackingState
});
export default rootReducer;
